var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Card from "../../Layout/Card";
import { StyledFeedItem } from "./FeedItem";
export var StyledFeed = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding: 0;\n  border-radius: 3px;\n\n  ", " {\n    :hover {\n      background-color: ", ";\n      cursor: pointer;\n    }\n  }\n  ", ":first-child {\n    border-radius: 6px 6px 0 0;\n  }\n"], ["\n  position: relative;\n  padding: 0;\n  border-radius: 3px;\n\n  ", " {\n    :hover {\n      background-color: ", ";\n      cursor: pointer;\n    }\n  }\n  ", ":first-child {\n    border-radius: 6px 6px 0 0;\n  }\n"])), StyledFeedItem, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.lightest;
}, StyledFeedItem);
var templateObject_1;
